/**
 * Hook that triggers auto-send when a template fill produces a pending send signal.
 */

import { useEffect } from 'react'

interface UseTemplateAutoSendParams {
  isPendingSend: boolean
  clearPendingSend: () => void
  onSend: () => void
}

export const useTemplateAutoSend = ({
  isPendingSend,
  clearPendingSend,
  onSend,
}: UseTemplateAutoSendParams): void => {
  useEffect(() => {
    if (!isPendingSend) return
    clearPendingSend()
    onSend()
  }, [isPendingSend, clearPendingSend, onSend])
}
